/* Airborne Dealers page -> Google Sheet/Drive (assets/dealer-to-sheet.js).
 * Loaded only by snippets/dealer-uploads.liquid on templates/page.dealers.json.
 * Posts to the Airborne Sheet Router (one Apps Script web app for all forms) with form=dealer + shared token.
 * Never blocks or alters the Shopify contact submit (email to epic.support@airborne.bike still goes out).
 */
(function () {
  var SHEET_URL = 'https://script.google.com/macros/s/AKfycbx39OWfEyk0PaBDAd_w8YAmKqk9H3pxgKsGAN3b7oYVvJrCDGfOGr_dXPNoKYN0Eqz6iA/exec';
  var ROUTER_FORM = 'dealer', ROUTER_TOKEN = '39cb3c17efdc486aacebe8b29376590b'; // shared form secret, by design public
  if (SHEET_URL.indexOf('REPLACE_') > -1) return;
  if (location.pathname.indexOf('/pages/dealers') !== 0) return;
  var MAX = 2000, Q = 0.8;
  var cache = {}; // slot -> base64 JPEG, prepared on file selection so submit stays synchronous

  function downscale(file) {
    return new Promise(function (res, rej) {
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function () {
        var s = Math.min(1, MAX / Math.max(img.naturalWidth, img.naturalHeight));
        var c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * s); c.height = Math.round(img.naturalHeight * s);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        res(c.toDataURL('image/jpeg', Q).split(',')[1]);
      };
      img.onerror = rej; img.src = url;
    });
  }

  var cert = null; // {b64, mime}; PDFs are sent as-is, JPG/PNG downscaled like photos
  function readRaw(file) {
    return new Promise(function (res, rej) {
      var r = new FileReader(); r.onload = function () { res(String(r.result).split(',')[1]); }; r.onerror = rej; r.readAsDataURL(file);
    });
  }
  document.addEventListener('change', function (ev) {
    var el = ev.target;
    if (!el || !el.hasAttribute || !el.hasAttribute('data-dealer-cert')) return;
    cert = null;
    var f = el.files && el.files[0]; if (!f) return;
    if (/pdf$/i.test(f.type) || /\.pdf$/i.test(f.name)) readRaw(f).then(function (b) { cert = { b64: b, mime: 'application/pdf' }; }).catch(function () {});
    else if (/^image\/(jpeg|png)$/i.test(f.type)) downscale(f).then(function (b) { cert = { b64: b, mime: 'image/jpeg' }; }).catch(function () {});
  });

  document.addEventListener('change', function (ev) {
    var el = ev.target, slot = el && el.getAttribute && el.getAttribute('data-dealer-photo');
    if (!slot) return;
    delete cache[slot];
    if (el.files && el.files[0]) downscale(el.files[0]).then(function (b) { cache[slot] = b; }).catch(function () {});
  });

  function post(params) {
    params.set('form', ROUTER_FORM); params.set('token', ROUTER_TOKEN);
    try { fetch(SHEET_URL, { method: 'POST', mode: 'no-cors', keepalive: params.toString().length < 60000, body: params }); } catch (e) {}
  }

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.id || form.id.indexOf('ContactForm-') !== 0) return;
    try {
      var id = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      var slots = Object.keys(cache).filter(function (s) { return form.querySelector('[data-dealer-photo="' + s + '"]'); }); // only sections still shown
      var flag = form.querySelector('input[name="contact[Dealer - Photos]"]');
      if (flag) flag.value = slots.length ? 'Yes - ' + slots.length + ' photo(s) uploaded to Drive (see sheet)' : 'None';
      var cflag = form.querySelector('input[name="contact[Dealer - Tax Certificate Upload]"]');
      if (cflag) cflag.value = cert ? 'Yes - uploaded to Drive (see sheet)' : 'None';
      var params = new URLSearchParams(); params.append('submission_id', id);
      Array.prototype.forEach.call(form.elements, function (el) {
        if (!el.name || el.name.indexOf('contact[') !== 0) return;  // skips hCaptcha, form_type, utf8, file inputs
        if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
        params.append(el.name, el.value);
      });
      post(params); // text row first
      var shopName = (form.querySelector('[name^="contact[Dealer - Shop"]') || {}).value || '';
      if (cert) {
        var cp = new URLSearchParams(); cp.append('submission_id', id);
        cp.append('contact[Dealer - Shop Name]', shopName);
        cp.append('cert_file', cert.b64); cp.append('cert_mime', cert.mime);
        post(cp);
      }
      slots.forEach(function (slot) {      // then one post per photo (~0.5-1.5 MB each)
        var p = new URLSearchParams(); p.append('submission_id', id);
        p.append('contact[Dealer - Shop Name]', (form.querySelector('[name^="contact[Dealer - Shop"]') || {}).value || '');
        p.append('photo_' + slot, cache[slot]);
        post(p);
      });
    } catch (e) { /* never interfere with the real submit */ }
  }, true);
})();
